"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _rcMenu = _interopRequireWildcard(require("rc-menu"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbUtils = require("ykb-utils");
var _StyledMenu = require("./StyledMenu");
var _ykbStyledComponents = require("../ykb-styled-components");
var _Icon = _interopRequireDefault(require("../Icon"));
var _reactDom = require("react-dom");
var _excluded = ["prefixCls", "withoutStyle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ExpandIcon = function ExpandIcon(_ref) {
  var rootprefixcls = _ref.rootprefixcls;
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "angle-down",
    className: "expand-icon"
  });
};
var Menu = /*#__PURE__*/function (_Component) {
  function Menu() {
    (0, _classCallCheck2.default)(this, Menu);
    return _callSuper(this, Menu, arguments);
  }
  (0, _inherits2.default)(Menu, _Component);
  return (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = (0, _reactDom.findDOMNode)(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        prefixCls = _this$props.prefixCls,
        withoutStyle = _this$props.withoutStyle,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledMenu.StyledContainer, {
          theme: theme,
          prefixCls: prefixCls,
          withoutStyle: withoutStyle
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_rcMenu.default, (0, _extends2.default)({
            getPopupContainer: function getPopupContainer() {
              return (0, _ykbUtils.containerChecker)(_this.node);
            },
            expandIcon: ExpandIcon
          }, rest, {
            prefixCls: styledPrefix
          }));
        });
      });
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Menu, "Item", _rcMenu.Item);
(0, _defineProperty2.default)(Menu, "SubMenu", _rcMenu.SubMenu);
(0, _defineProperty2.default)(Menu, "Divider", _rcMenu.Divider);
(0, _defineProperty2.default)(Menu, "ItemGroup", _rcMenu.ItemGroup);
Menu.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  mode: _propTypes.default.oneOf(['horizontal', 'inline', 'vertical', 'vertical-left', 'vertical-right']),
  onSelect: _propTypes.default.func,
  onClick: _propTypes.default.func,
  defaultActiveFirst: _propTypes.default.bool,
  defaultSelectedKeys: _propTypes.default.array,
  defaultOpenKeys: _propTypes.default.array,
  selectedKeys: _propTypes.default.array,
  expandIcon: _propTypes.default.element,
  withoutStyle: _propTypes.default.bool,
  prefixCls: _propTypes.default.string
};
Menu.defaultProps = {
  className: '',
  defaultActiveFirst: false,
  defaultSelectedKeys: [],
  defaultOpenKeys: [],
  selectedKeys: [],
  mode: 'vertical',
  withoutStyle: false
};
var _default = exports.default = Menu;